import React, { useEffect } from 'react';

import { Divider, Loading } from '@cobliteam/ui/components';
import { withStyles } from '@material-ui/core';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import { Dialog } from '@cobliteam/base-components';

import Alert from '@cobliteam/ui/components/Alert';
import MediaDialogBanner from './components/MediaDialogBanner/MediaDialogBanner';
import MediaDialogBody from './components/MediaDialogBody/MediaDialogBody';
import MediaDialogDriverInfo from './components/MediaDialogDriverInfo/MediaDialogDriverInfo';
import MediaDialogFooter from './components/MediaDialogFooter/MediaDialogFooter';
import MediaDialogHeader from './components/MediaDialogHeader/MediaDialogHeader';

import MediaVideoPlayer from '../../containers/MediaDetails/components/MediaVideoPlayer';
import useMediaStore from '../../store/zustand/useMediaStore';

export interface MediaDialogProps {
  origin?: string;
  onClose: () => void;
  onNextMediaClick?: () => void;
  onPreviousMediaClick?: () => void;
  hasNextMedia?: boolean;
  hasPreviousMedia?: boolean;
  isNavigationButtonsDisabled?: boolean;
  isFetchingMediaRows?: boolean;
  redirectButton?: JSX.Element;
}
const BorderlessDialog = withStyles(() => ({
  paper: {
    border: 'unset',
  },
}))(Dialog);

export const MediaDialog: React.FC<MediaDialogProps> = React.memo(
  ({ origin, onClose, onNextMediaClick, onPreviousMediaClick, isNavigationButtonsDisabled, hasPreviousMedia, hasNextMedia, isFetchingMediaRows, redirectButton }) => {
    const mediaViewId = useMediaStore((state) => state.mediaViewId);

    const { data: mediaView, isError, isFetched } = useGetMediaView(mediaViewId);

    const mediaUrl = mediaView?.mediaUrl;

    useEffect(() => {
      if (isError || (isFetched && !mediaUrl)) {
        Alert.error('Erro ao obter dados do vídeo.');
        onClose();
      }
    }, [mediaUrl, isError, isFetched]);

    return (
      <BorderlessDialog open={!!mediaViewId} overflowY='auto' onClose={onClose} maxWidth='lg'>
        <MediaDialogHeader onClose={onClose} isFetchingMediaRows={isFetchingMediaRows} />
        <Divider />
        <MediaDialogBanner isFetchingMediaRows={isFetchingMediaRows} />
        <MediaDialogDriverInfo isFetchingMediaRows={isFetchingMediaRows} />
        {mediaView ? (
          <div className='m-5'>
            <MediaVideoPlayer mediaView={mediaView} />
          </div>
        ) : (
          <div className='flex h-72 w-full items-center justify-center'>
            <Loading />
          </div>
        )}

        <MediaDialogBody isFetchingMediaRows={isFetchingMediaRows} />
        <Divider />
        <MediaDialogFooter
          onNextMediaClick={onNextMediaClick}
          onPreviousMediaClick={onPreviousMediaClick}
          hasPreviousMedia={hasPreviousMedia}
          hasNextMedia={hasNextMedia}
          isNavigationButtonsDisabled={isNavigationButtonsDisabled}
          isFetchingMediaRows={isFetchingMediaRows}
          redirectButton={redirectButton}
        />
      </BorderlessDialog>
    );
  }
);

export default MediaDialog;
